
import { Browse } from "@/models/browse";
import { UserConfigService } from "@/services/user-config-service";
import Vue from "vue";
import { Model } from "../../../utils/models/model";
import AppSearchSettingsAddColumnModal from "./SearchSettingsAddColumnModal.vue";

export default Vue.extend({
	data() {
		let settings = UserConfigService.getBrowseSearchSettings();
		return {
			addModal: false,
			columns: settings.getSettings(this.browse),
			settings
		};
	},
	props: {
		browse: {
			type: Object as () => Browse,
			required: true
		}
	},
	computed: {
		model(): Model {
			return this.browse.type;
		},
	},
	methods: {
		async save() {
			await UserConfigService.setBrowseSearchSettings(this.settings);
		},
		getFriendlyName(column: string): string {
			let field = this.model.getFilterField(column);
			if (!field) {
				let namedField = this.model.getAvailableNamedFilters().find(f=>f.name == column);
				if (!namedField) {
					return column;
				}
				return namedField.getDisplayName(this.model).toString();
			};
			return field.getPropertyTranslation();
		},
		removeColumn(i: number) {
			this.columns.splice(i, 1);
			this.save();
		}
	},
	components: {
		AppSearchSettingsAddColumnModal
	},
	i18nEx: {
		componentPrefix: "components.settings-browse"
	}
});
